import { render, staticRenderFns } from "./StdItemTxtDefBen.vue?vue&type=template&id=2218184b&"
import script from "./StdItemTxtDefBen.vue?vue&type=script&lang=js&"
export * from "./StdItemTxtDefBen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports